import React, { useEffect, useState } from 'react';
import { Icon, Spin } from 'antd';
import { tableauJwToken } from 'src/api/tableauJwt';

type TableauViewProps = {
  reportUrl: string;
};

const antIcon = <Icon type="loading" spin />;
const TableauView: React.FC<TableauViewProps> = ({ reportUrl }) => {
  const [token, setToken] = useState<string | null>(null);

  useEffect(() => {
    const getToken = async () => {
      try {
        const fetchedToken = await tableauJwToken();
        setToken(fetchedToken);
      } catch (err) {
        console.error(err);
      }
    };

    getToken();
  }, []);

  if (!token) {
    return <Spin indicator={antIcon} size={'large'} />;
  }

  return (
    <div>
      <tableau-viz id="tableauViz" token={token} src={reportUrl} toolbar="bottom" hideTabs></tableau-viz>
    </div>
  );
};

export default TableauView;
